import React from 'react';
export function useTransitionEvent(callback) {
  var targetElement = React.useRef(null);
  React.useEffect(function () {
    var currentTargetElement = targetElement.current;

    if (currentTargetElement) {
      currentTargetElement.addEventListener('transitionstart', callback);
      currentTargetElement.addEventListener('transitionend', callback);
    }

    return function () {
      if (currentTargetElement) {
        currentTargetElement.removeEventListener('transitionstart', callback);
        currentTargetElement.removeEventListener('transitionend', callback);
      }
    };
  });
  return targetElement;
}